import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Heading, Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const ProgressCard = ({ title, primaryValue, secondaryValue }) => (
  <Card className="progress-card">
    <Card className="progress-card__number">
      <Heading type="h3" font="united">
        {primaryValue ?? '--'}
      </Heading>
      <Paragraph>{secondaryValue ?? '--'}</Paragraph>
    </Card>
    <Paragraph className="progress-card__name">{title}</Paragraph>
  </Card>
)

export default ProgressCard
